{
  "version": 1,
  "asset_id": "628b7e6d-ffd4-4ffd-9f38-d96e99d8f97f",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/628b7e6d-ffd4-4ffd-9f38-d96e99d8f97f/beylikduzu-hizli-elektrikci-7-24-dukkan-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/628b7e6d-ffd4-4ffd-9f38-d96e99d8f97f/beylikduzu-hizli-elektrikci-7-24-dukkan-6.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-6.jpg",
  "size": 417593,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:47Z"
}
